import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-verify',
  templateUrl: './admin-verify.component.html',
  styleUrls: ['./admin-verify.component.css']
})
export class AdminVerifyComponent implements OnInit {

  constructor(private auth:AuthService,private route:Router) { }

  ngOnInit() {
  }
  logout(){
    this.auth.logout()
   document.getElementById('adminVerified').click()
    this.route.navigate(['/'])

  }

}
